// src/data/medleCases.js - OVERWRITE COMPLETELY (100 Case Question Bank)

export const MEDLE_CASES = [
    {
        "ID": "C001",
        "Correct Diagnosis": "Acute Myocardial Infarction",
        "Specialty": "Cardiology",
        "Summary": "Substernal chest pain radiating to the arm, tachycardia, and definitive labs/EKG (Troponin/ST elevation) point straight to MI.",
        "Keywords": ["acute", "myocardial", "infarction", "mi", "stemi", "heart"],
        "Clue_1": "68 y/o male presents with sudden onset crushing chest pain radiating to the left arm.",
        "Clue_2": "Tachycardia (HR 110) and crackles heard on lung auscultation.",
        "Clue_3": "Elevated Troponin I and ST-segment elevation on EKG.",
        "Clue_4": "History of hypertension, hyperlipidemia, and smoking.",
        "Clue_5": "Treatment started with Aspirin and Heparin.",
        "Max_Clues": 5
    },
    {
        "ID": "C002",
        "Correct Diagnosis": "Multiple Sclerosis",
        "Specialty": "Neurology",
        "Summary": "The combination of visual disturbances (optic neuritis) and motor weakness separated in time and space is the hallmark of MS.",
        "Keywords": ["multiple", "sclerosis", "ms", "demyelination", "optic", "weakness"],
        "Clue_1": "35 y/o female reports sudden, painful loss of vision in her right eye that resolved two weeks later.",
        "Clue_2": "She later develops numbness and difficulty coordinating her left leg.",
        "Clue_3": "MRI shows multiple hyperintense plaques in the periventricular white matter and spinal cord.",
        "Clue_4": "Symptoms relapse and remit over several months.",
        "Clue_5": "CSF analysis shows elevated IgG index and oligoclonal bands.",
        "Max_Clues": 5
    },
    {
        "ID": "C003",
        "Correct Diagnosis": "Community-Acquired Pneumonia",
        "Specialty": "Infectious Disease",
        "Summary": "Productive cough, fever, and classic consolidation on chest imaging confirm CAP, typically caused by S. pneumoniae.",
        "Keywords": ["community", "acquired", "pneumonia", "cap", "strep", "pna", "fever", "cough"],
        "Clue_1": "70 y/o presents with acute onset fever, chills, and productive cough with rust-colored sputum.",
        "Clue_2": "Physical exam reveals tactile fremitus and dullness to percussion over the right lower lobe.",
        "Clue_3": "Chest X-ray shows lobar consolidation in the right lower lung field.",
        "Clue_4": "WBC count is elevated with left shift (neutrophilia).",
        "Clue_5": "Empiric treatment started with Azithromycin and Ceftriaxone.",
        "Max_Clues": 5
    },
    {
        "ID": "C004",
        "Correct Diagnosis": "Acute Pancreatitis",
        "Specialty": "Gastroenterology",
        "Summary": "Severe epigastric pain radiating to the back, highly elevated lipase, and risk factors (alcohol, gallstones) are classic for acute pancreatitis.",
        "Keywords": ["acute", "pancreatitis", "lipase", "epigastric", "pain", "gallstones"],
        "Clue_1": "45 y/o male reports severe, steady pain in the epigastrium radiating straight to the back.",
        "Clue_2": "Pain is significantly worse after eating a fatty meal and is partially relieved by leaning forward.",
        "Clue_3": "Serum Lipase level is > 3 times the upper limit of normal.",
        "Clue_4": "Patient has a history of heavy alcohol use.",
        "Clue_5": "CT scan reveals diffuse pancreatic edema and peripancreatic fluid collection.",
        "Max_Clues": 5
    },
    {
        "ID": "C005",
        "Correct Diagnosis": "Psoriasis",
        "Specialty": "Dermatology",
        "Summary": "Well-demarcated erythematous plaques with silvery scales, especially on extensor surfaces (elbows/knees), are diagnostic of Psoriasis.",
        "Keywords": ["psoriasis", "plaque", "silvery", "scale", "erythematous", "elbow"],
        "Clue_1": "28 y/o presents with persistent itchy skin lesions on his elbows and knees.",
        "Clue_2": "The lesions are sharply demarcated, red, raised, and covered by a thick, flaky white scale.",
        "Clue_3": "Positive Auspitz sign (pinpoint bleeding when the scale is removed).",
        "Clue_4": "Patient reports stiffness and pain in his hands in the mornings (Psoriatic Arthritis link).",
        "Clue_5": "Skin biopsy shows epidermal hyperplasia and downward extension of rete ridges.",
        "Max_Clues": 5
    },
    {
        "ID": "C006",
        "Correct Diagnosis": "Type 1 Diabetes Mellitus",
        "Specialty": "Endocrinology",
        "Summary": "Rapid onset of polyuria, polydipsia (poly's), weight loss, and high anion gap metabolic acidosis points to new-onset Type 1 DM.",
        "Keywords": ["type 1", "diabetes", "mellitus", "dm", "insulin", "polyuria"],
        "Clue_1": "14 y/o female admitted with rapid weight loss, intense thirst (polydipsia), and frequent urination (polyuria).",
        "Clue_2": "Blood glucose level is 350 mg/dL and urinalysis is positive for ketones.",
        "Clue_3": "Arterial blood gas shows pH 7.25 and a high anion gap.",
        "Clue_4": "HbA1c is 9.8%, indicating prolonged hyperglycemia.",
        "Clue_5": "Labs confirm presence of glutamic acid decarboxylase (GAD) autoantibodies.",
        "Max_Clues": 5
    },
    {
        "ID": "C007",
        "Correct Diagnosis": "Anterior Cruciate Ligament Tear",
        "Specialty": "Orthopedics",
        "Summary": "Mechanism of injury (pivot/hyperextension) combined with the 'pop' sensation and instability suggests ACL tear.",
        "Keywords": ["anterior", "cruciate", "ligament", "acl", "tear", "knee"],
        "Clue_1": "22 y/o soccer player twisted her knee while planting her foot; reports hearing an audible 'pop'.",
        "Clue_2": "Immediately developed significant swelling and inability to bear weight.",
        "Clue_3": "Positive Lachman test and Anterior Drawer sign noted on physical examination.",
        "Clue_4": "MRI confirms complete disruption of the ACL fibers.",
        "Clue_5": "Surgical reconstruction (allograft/autograft) is planned.",
        "Max_Clues": 5
    },
    {
        "ID": "C008",
        "Correct Diagnosis": "Acute Kidney Injury",
        "Specialty": "Nephrology",
        "Summary": "Acute rise in BUN and Creatinine (Azotemia) following severe dehydration (fever, vomiting) points to prerenal AKI.",
        "Keywords": ["acute", "kidney", "injury", "aki", "prerenal", "creatinine", "bun"],
        "Clue_1": "60 y/o male admitted with persistent high fever and vomiting for 3 days; reports extreme thirst.",
        "Clue_2": "Blood pressure is 90/60 mmHg (Hypotension) and patient is tachycardic.",
        "Clue_3": "Labs show sudden rise in serum Creatinine from 1.0 to 2.8 mg/dL.",
        "Clue_4": "Urine sodium is low (FeNa < 1%) and urine specific gravity is high.",
        "Clue_5": "Condition rapidly improves after intravenous fluid resuscitation.",
        "Max_Clues": 5
    },
    {
        "ID": "C009",
        "Correct Diagnosis": "Pulmonary Embolism",
        "Specialty": "Pulmonology",
        "Summary": "Acute onset dyspnea and pleuritic chest pain in a patient with risk factors (immobilization, surgery) is highly suspicious for PE.",
        "Keywords": ["pulmonary", "embolism", "pe", "dvt", "dyspnea", "pleuritic"],
        "Clue_1": "55 y/o admitted post-hip surgery; reports sudden onset severe shortness of breath and sharp, pleuritic chest pain.",
        "Clue_2": "Vitals show hypoxia (SpO2 88%) and tachypnea, but lung sounds are clear.",
        "Clue_3": "D-dimer level is significantly elevated.",
        "Clue_4": "CT Pulmonary Angiogram (CTPA) reveals a large filling defect in the right pulmonary artery.",
        "Clue_5": "Anticoagulation therapy (Heparin/Warfarin) is initiated.",
        "Max_Clues": 5
    },
    {
        "ID": "C010",
        "Correct Diagnosis": "Sickle Cell Crisis",
        "Specialty": "Hematology",
        "Summary": "Sudden, severe pain in the extremities or back in a patient with known Sickle Cell Disease, often triggered by stress or infection.",
        "Keywords": ["sickle", "cell", "crisis", "pain", "vaso-occlusive", "dactylitis"],
        "Clue_1": "18 y/o with known Sickle Cell Disease presents with acute, excruciating pain in his left arm and lower back.",
        "Clue_2": "Patient has a fever but no signs of localized infection.",
        "Clue_3": "CBC shows chronic anemia (Hgb 7.5 g/dL) and high Reticulocyte Count.",
        "Clue_4": "Peripheral blood smear reveals presence of crescent-shaped red blood cells.",
        "Clue_5": "Pain management initiated using high-dose opioid analgesics and intravenous hydration.",
        "Max_Clues": 5
    },
    {
        "ID": "C011",
        "Correct Diagnosis": "Osteoarthritis",
        "Specialty": "Orthopedics",
        "Summary": "Progressive joint pain worsened by activity and relieved by rest, with X-ray evidence of joint space narrowing and osteophytes.",
        "Keywords": ["osteoarthritis", "joint", "pain", "rest", "activity"],
        "Clue_1": "65 y/o reports stiffness and pain in the knees, worse in the evening after activity.",
        "Clue_2": "Physical exam shows crepitus and mild effusion in the knee joints.",
        "Clue_3": "X-ray confirms joint space narrowing, subchondral sclerosis, and marginal osteophytes.",
        "Clue_4": "Managed initially with NSAIDs and exercise.",
        "Clue_5": "Weight loss and physical therapy are recommended management strategies.",
        "Max_Clues": 5
    },
    {
        "ID": "C012",
        "Correct Diagnosis": "Gastroesophageal Reflux Disease",
        "Specialty": "Gastroenterology",
        "Summary": "Chronic heartburn and regurgitation, often worse when lying down or bending over, are classic GERD symptoms.",
        "Keywords": ["gastroesophageal", "reflux", "gerd", "heartburn", "regurgitation", "esophagitis"],
        "Clue_1": "40 y/o reports frequent heartburn and sour taste in the mouth, especially at night.",
        "Clue_2": "Symptoms are often triggered by large meals or consumption of citrus and chocolate.",
        "Clue_3": "Upper endoscopy shows mild erosive changes (esophagitis) in the distal esophagus.",
        "Clue_4": "Treatment includes PPIs (Proton Pump Inhibitors) and lifestyle changes.",
        "Clue_5": "Avoidance of late-night eating is a primary recommendation.",
        "Max_Clues": 5
    },
    {
        "ID": "C013",
        "Correct Diagnosis": "Hyperthyroidism (Graves' Disease)",
        "Specialty": "Endocrinology",
        "Summary": "Weight loss despite increased appetite, tremor, heat intolerance, and ophthalmopathy strongly suggest hyperthyroidism.",
        "Keywords": ["hyperthyroidism", "graves", "disease", "tremor", "heat", "tsh"],
        "Clue_1": "30 y/o female reports unexplained weight loss despite an increased appetite and severe anxiety.",
        "Clue_2": "Physical exam reveals a fine tremor in the hands and noticeable bulging of the eyes (exophthalmos).",
        "Clue_3": "Labs show low TSH (Thyroid Stimulating Hormone) and elevated free T4.",
        "Clue_4": "Radioactive Iodine Uptake (RAIU) scan shows diffuse, high uptake.",
        "Clue_5": "Treatment options include anti-thyroid medications or radioactive iodine ablation.",
        "Max_Clues": 5
    },
    {
        "ID": "C014",
        "Correct Diagnosis": "Atrial Fibrillation",
        "Specialty": "Cardiology",
        "Summary": "Irregularly irregular pulse, palpitations, and ECG showing absent P waves and rapid, disorganized rhythm confirm A-Fib.",
        "Keywords": ["atrial", "fibrillation", "afib", "pulse", "palpitations", "ecg"],
        "Clue_1": "68 y/o patient reports sudden onset palpitations and feeling lightheaded and short of breath.",
        "Clue_2": "Physical exam reveals a rapid, irregularly irregular pulse (HR 130 bpm).",
        "Clue_3": "ECG shows absent P waves with irregular R-R intervals and a narrow complex tachycardia.",
        "Clue_4": "Patient has a history of poorly controlled hypertension.",
        "Clue_5": "Risk assessment using CHA2DS2-VASc score suggests need for anticoagulation (Warfarin/DOACs).",
        "Max_Clues": 5
    },
    {
        "ID": "C015",
        "Correct Diagnosis": "Tinea Corporis (Ringworm)",
        "Specialty": "Dermatology",
        "Summary": "Annular (ring-shaped) lesion with central clearing and raised, scaly borders is classic dermatophyte infection.",
        "Keywords": ["tinea", "corporis", "ringworm", "fungal", "annular", "scale"],
        "Clue_1": "10 y/o presents with an itchy, round skin lesion on the forearm.",
        "Clue_2": "The lesion has a prominent raised red border and a clearer area in the center.",
        "Clue_3": "KOH prep of skin scrapings shows branching, septate hyphae.",
        "Clue_4": "Topical antifungal creams (e.g., Clotrimazole) are prescribed.",
        "Clue_5": "Avoid sharing towels and bedding to prevent spread.",
        "Max_Clues": 5
    },
    {
        "ID": "C016",
        "Correct Diagnosis": "Cerebrovascular Accident (Stroke)",
        "Specialty": "Neurology",
        "Summary": "Acute focal neurological deficits (hemiparesis, dysarthria, facial droop) are the defining features of a stroke.",
        "Keywords": ["cerebrovascular", "stroke", "accident", "cva", "hemiparesis"],
        "Clue_1": "75 y/o male presents with sudden onset weakness on the entire left side of his body (hemiparesis).",
        "Clue_2": "Patient is unable to speak clearly (dysarthria) and has an obvious facial droop.",
        "Clue_3": "CT scan of the head confirms an acute hypodensity consistent with an ischemic stroke.",
        "Clue_4": "Symptoms onset occurred 90 minutes prior to arrival.",
        "Clue_5": "Treated urgently with intravenous tPA (tissue plasminogen activator).",
        "Max_Clues": 5
    },
    {
        "ID": "C017",
        "Correct Diagnosis": "Chronic Kidney Disease (Stage 5)",
        "Specialty": "Nephrology",
        "Summary": "Persistent azotemia, metabolic acidosis, severe anemia, and low eGFR (<15 ml/min) indicate end-stage renal failure.",
        "Keywords": ["chronic", "kidney", "disease", "ckd", "azotemia", "anemia"],
        "Clue_1": "55 y/o with long-standing diabetes and hypertension reports severe fatigue and generalized itching (pruritus).",
        "Clue_2": "Labs show eGFR is 12 ml/min, BUN 85, and Creatinine 5.1 mg/dL.",
        "Clue_3": "Severe normocytic anemia (Hgb 8.0) and hyperphosphatemia are present.",
        "Clue_4": "Patient shows signs of asterixis and peripheral neuropathy.",
        "Clue_5": "Patient placed on the list for dialysis initiation.",
        "Max_Clues": 5
    },
    {
        "ID": "C018",
        "Correct Diagnosis": "Asthma Exacerbation",
        "Specialty": "Pulmonology",
        "Summary": "Acute worsening of wheezing and dyspnea, responsive to bronchodilators, in a patient with known airway hyperreactivity.",
        "Keywords": ["asthma", "wheezing", "dyspnea", "bronchodilator", "peak"],
        "Clue_1": "16 y/o presents to the ER with acute shortness of breath and audible wheezing.",
        "Clue_2": "Patient reports recent exposure to pollen and failure of her rescue inhaler.",
        "Clue_3": "Physical exam reveals diffuse inspiratory and expiratory wheezes; decreased oxygen saturation.",
        "Clue_4": "Spirometry confirms FEV1 significantly lower than baseline.",
        "Clue_5": "Treatment involves inhaled short-acting beta agonists (SABA) and systemic corticosteroids.",
        "Max_Clues": 5
    },
    {
        "ID": "C019",
        "Correct Diagnosis": "Clostridium Difficile Colitis",
        "Specialty": "Infectious Disease",
        "Summary": "Severe, watery diarrhea following antibiotic use, confirmed by toxin assay, is classic C. diff infection.",
        "Keywords": ["clostridium", "difficile", "cdiff", "colitis", "diarrhea", "antibiotics"],
        "Clue_1": "60 y/o female develops profuse, watery diarrhea 5 days after completing a course of Clindamycin.",
        "Clue_2": "Stool frequency is >10 times per day, accompanied by abdominal cramping and fever.",
        "Clue_3": "Stool test is positive for C. difficile Toxin A and B.",
        "Clue_4": "Colonoscopy reveals pseudomembranous colitis.",
        "Clue_5": "Treatment includes oral Vancomycin or Fidaxomicin.",
        "Max_Clues": 5
    },
    {
        "ID": "C020",
        "Correct Diagnosis": "Iron Deficiency Anemia",
        "Specialty": "Hematology",
        "Summary": "Microcytic anemia with low ferritin, high TIBC, and symptoms like fatigue and pica are key markers of iron deficiency.",
        "Keywords": ["iron", "deficiency", "anemia", "microcytic", "ferritin", "pica"],
        "Clue_1": "30 y/o female reports generalized fatigue and weakness for months.",
        "Clue_2": "Patient reports craving and chewing ice (pica).",
        "Clue_3": "CBC shows Hgb 8.5 g/dL, MCV 72 fL (microcytic hypochromic).",
        "Clue_4": "Low serum ferritin and high total iron-binding capacity (TIBC) are noted.",
        "Clue_5": "Treatment initiated with oral ferrous sulfate supplements.",
        "Max_Clues": 5
    },
    {
        "ID": "C021",
        "Correct Diagnosis": "Bacterial Meningitis",
        "Specialty": "Neurology",
        "Summary": "Acute fever, nuchal rigidity (stiff neck), and altered mental status are the critical triad of meningitis.",
        "Keywords": ["bacterial", "meningitis", "fever", "nuchal", "rigidity", "cns"],
        "Clue_1": "25 y/o presents to the ER with sudden onset high fever, severe headache, and confusion.",
        "Clue_2": "Physical exam reveals nuchal rigidity and positive Brudzinski and Kernig signs.",
        "Clue_3": "Lumbar puncture shows elevated opening pressure, low glucose, and high protein in CSF.",
        "Clue_4": "Gram stain of CSF shows Gram-positive diplococci.",
        "Clue_5": "Empiric treatment started immediately with Vancomycin and Ceftriaxone.",
        "Max_Clues": 5
    },
    {
        "ID": "C022",
        "Correct Diagnosis": "Chronic Heart Failure (Systolic)",
        "Specialty": "Cardiology",
        "Summary": "Progressive dyspnea, orthopnea, elevated BNP, and low Ejection Fraction (EF) confirm systolic CHF.",
        "Keywords": ["chronic", "heart", "failure", "chf", "dyspnea", "orthopnea", "bnp"],
        "Clue_1": "70 y/o reports worsening shortness of breath, inability to lie flat (orthopnea), and bilateral leg swelling.",
        "Clue_2": "Physical exam shows jugular venous distention (JVD) and bibasilar crackles.",
        "Clue_3": "B-type Natriuretic Peptide (BNP) levels are significantly elevated.",
        "Clue_4": "Echocardiogram reveals an Ejection Fraction (EF) of 30%.",
        "Clue_5": "Managed with diuretics, ACE inhibitors/ARBs, and Beta-blockers.",
        "Max_Clues": 5
    },
    {
        "ID": "C023",
        "Correct Diagnosis": "Gout",
        "Specialty": "Endocrinology",
        "Summary": "Acute, severe joint pain (podagra) in the big toe, often following a rich meal, is classic gout.",
        "Keywords": ["gout", "podagra", "uric", "acid", "mcp", "hyperuricemia"],
        "Clue_1": "50 y/o male wakes up with agonizing pain, redness, and swelling in his right big toe (1st MCP joint).",
        "Clue_2": "Patient reports a recent weekend diet heavy in red meat and beer.",
        "Clue_3": "Serum Uric Acid level is elevated.",
        "Clue_4": "Arthrocentesis reveals negatively birefringent, needle-shaped crystals.",
        "Clue_5": "Treated initially with NSAIDs (Indomethacin) or Colchicine.",
        "Max_Clues": 5
    },
    {
        "ID": "C024",
        "Correct Diagnosis": "Basal Cell Carcinoma",
        "Specialty": "Dermatology",
        "Summary": "A slow-growing, pearly nodule with rolled borders and telangiectasias is the most common skin cancer.",
        "Keywords": ["basal", "cell", "carcinoma", "bcc", "pearly", "nodule", "skin"],
        "Clue_1": "60 y/o outdoor worker presents with a small, dome-shaped lesion on his nose that has slowly enlarged.",
        "Clue_2": "The lesion is described as translucent, 'pearly', with small blood vessels (telangiectasias) visible.",
        "Clue_3": "Patient has a history of significant sun exposure.",
        "Clue_4": "Diagnosis confirmed by shave biopsy.",
        "Clue_5": "Surgical excision (Mohs surgery) is the standard treatment.",
        "Max_Clues": 5
    },
    {
        "ID": "C025",
        "Correct Diagnosis": "Ulcerative Colitis",
        "Specialty": "Gastroenterology",
        "Summary": "Bloody diarrhea, tenesmus, continuous inflammation limited to the colon suggests UC.",
        "Keywords": ["ulcerative", "colitis", "uc", "bloody", "diarrhea", "colon", "inflammation"],
        "Clue_1": "30 y/o reports recurrent episodes of bloody diarrhea, abdominal pain, and urgency (tenesmus).",
        "Clue_2": "Symptoms have been progressive over the last few months.",
        "Clue_3": "Colonoscopy reveals continuous inflammation starting in the rectum and extending proximally.",
        "Clue_4": "Biopsy shows crypt abscesses and infiltration of neutrophils.",
        "Clue_5": "Managed with 5-ASA compounds (Mesalamine) or corticosteroids during flares.",
        "Max_Clues": 5
    },
    {
        "ID": "C026",
        "Correct Diagnosis": "Rheumatoid Arthritis",
        "Specialty": "Orthopedics",
        "Summary": "Symmetric, morning stiffness in small joints (MCPs, PIPs) lasting >1 hour, confirmed by anti-CCP and RF.",
        "Keywords": ["rheumatoid", "arthritis", "ra", "morning", "stiffness", "symmetric", "pip"],
        "Clue_1": "45 y/o female reports symmetric swelling and pain in the wrists and small joints of the hands.",
        "Clue_2": "Stiffness is severe and lasts for more than 90 minutes every morning.",
        "Clue_3": "Labs show positive Rheumatoid Factor (RF) and high Anti-Cyclic Citrullinated Peptide (Anti-CCP) antibodies.",
        "Clue_4": "X-rays show erosions and joint space narrowing.",
        "Clue_5": "Treatment involves DMARDS (Methotrexate) and biologics.",
        "Max_Clues": 5
    },
    {
        "ID": "C027",
        "Correct Diagnosis": "Diabetic Nephropathy",
        "Specialty": "Nephrology",
        "Summary": "Proteinuria (microalbuminuria progressing to macroalbuminuria) in a patient with long-standing poorly controlled DM.",
        "Keywords": ["diabetic", "nephropathy", "proteinuria", "diabetes", "gfr"],
        "Clue_1": "60 y/o with 20 years of Type 2 DM reports increasing bilateral leg swelling and foamy urine.",
        "Clue_2": "Urine dipstick shows 3+ protein; 24-hour urine collection confirms macroalbuminuria.",
        "Clue_3": "eGFR is slowly declining over the last three years.",
        "Clue_4": "Treated primarily with ACE Inhibitors/ARBs, strict glucose control, and blood pressure management.",
        "Clue_5": "Avoidance of late-night eating is a primary recommendation.",
        "Max_Clues": 5
    },
    {
        "ID": "C028",
        "Correct Diagnosis": "Chronic Obstructive Pulmonary Disease",
        "Specialty": "Pulmonology",
        "Summary": "Long smoking history, chronic productive cough, and irreversible airflow limitation on spirometry are hallmarks of COPD.",
        "Keywords": ["chronic", "obstructive", "pulmonary", "disease", "copd", "smoking", "fev1"],
        "Clue_1": "65 y/o heavy smoker reports increasing dyspnea over the last year, especially with exertion.",
        "Clue_2": "Physical exam reveals a barrel chest and prolonged expiratory phase.",
        "Clue_3": "PFTs show FEV1/FVC ratio is less than 0.70 post-bronchodilator.",
        "Clue_4": "Patient reports daily productive cough for the last 15 years.",
        "Clue_5": "Treatment includes bronchodilators (LABA/LAMA) and inhaled corticosteroids.",
        "Max_Clues": 5
    },
    {
        "ID": "C029",
        "Correct Diagnosis": "Human Immunodeficiency Virus (Acute)",
        "Specialty": "Infectious Disease",
        "Summary": "Mononucleosis-like syndrome (fever, rash, lymphadenopathy) following a high-risk exposure event.",
        "Keywords": ["human", "immunodeficiency", "virus", "hiv", "acute", "seroconversion"],
        "Clue_1": "3 weeks after unprotected sexual exposure, 28 y/o reports a severe flu-like illness, high fever, and diffuse maculopapular rash.",
        "Clue_2": "Physical exam shows generalized lymphadenopathy and painful oral ulcers.",
        "Clue_3": "Rapid HIV antibody test is negative; however, HIV viral load is extremely high (millions).",
        "Clue_4": "Diagnosis confirmed by HIV p24 antigen and nucleic acid tests.",
        "Clue_5": "Treatment initiated urgently with highly active antiretroviral therapy (HAART).",
        "Max_Clues": 5
    },
    {
        "ID": "C030",
        "Correct Diagnosis": "Deep Vein Thrombosis",
        "Specialty": "Hematology",
        "Summary": "Unilateral leg swelling, pain, and a positive duplex ultrasound confirm DVT.",
        "Keywords": ["deep", "vein", "thrombosis", "dvt", "unilateral", "swelling", "calf"],
        "Clue_1": "40 y/o female who recently took a long-haul flight complains of sudden onset swelling and pain in her left calf.",
        "Clue_2": "Physical exam reveals erythema, warmth, and tenderness to palpation of the posterior calf.",
        "Clue_3": "Positive Homan's sign (pain on dorsiflexion of the foot).",
        "Clue_4": "Compression Ultrasound shows non-compressibility and presence of thrombus in the popliteal vein.",
        "Clue_5": "Treated immediately with therapeutic anticoagulation (LMWH or DOACs).",
        "Max_Clues": 5
    },
    {
        "ID": "C031",
        "Correct Diagnosis": "Hypertension",
        "Specialty": "Cardiology",
        "Summary": "Diagnosis of chronically elevated blood pressure, requiring lifestyle and pharmacological intervention.",
        "Keywords": ["hypertension", "bp", "elevated", "diagnosis", "chronic"],
        "Clue_1": "50 y/o male with no symptoms has multiple clinic readings of BP above 140/90 mmHg.",
        "Clue_2": "Patient is overweight and has a sedentary lifestyle.",
        "Clue_3": "Initial management involves dietary changes (DASH diet) and increased physical activity.",
        "Clue_4": "If BP remains high, pharmacological agents like ACE inhibitors are added.",
        "Clue_5": "Patient is monitored for signs of end-organ damage (e.g., left ventricular hypertrophy).",
        "Max_Clues": 5
    },
    {
        "ID": "C032",
        "Correct Diagnosis": "Migraine",
        "Specialty": "Neurology",
        "Summary": "Recurrent, unilateral, pulsatile headache, often accompanied by photophobia and nausea.",
        "Keywords": ["migraine", "headache", "unilateral", "pulsatile", "nausea"],
        "Clue_1": "30 y/o reports recurrent severe headaches, typically lasting 6-8 hours.",
        "Clue_2": "Headaches are always unilateral and described as 'throbbing' or 'pulsating'.",
        "Clue_3": "Attacks are often accompanied by severe light sensitivity (photophobia) and nausea.",
        "Clue_4": "Patient sometimes sees shimmering lights (aura) just before the headache begins.",
        "Clue_5": "Treated acutely with Triptans and preventatively with Beta-blockers.",
        "Max_Clues": 5
    },
    {
        "ID": "C033",
        "Correct Diagnosis": "Hyperparathyroidism",
        "Specialty": "Endocrinology",
        "Summary": "Elevated PTH and hypercalcemia ('stones, bones, groans, and psychic moans').",
        "Keywords": ["hyperparathyroidism", "pth", "calcium", "elevated"],
        "Clue_1": "65 y/o reports symptoms of extreme fatigue, constipation, and frequent urination.",
        "Clue_2": "Labs show persistently high serum Calcium and elevated Parathyroid Hormone (PTH).",
        "Clue_3": "DEXA scan shows generalized osteopenia (bone demineralization).",
        "Clue_4": "Surgical parathyroidectomy is often the definitive treatment.",
        "Clue_5": "Patient is monitored for signs of end-organ damage (e.g., left ventricular hypertrophy).",
        "Max_Clues": 5
    },
    {
        "ID": "C034",
        "Correct Diagnosis": "Acne Vulgaris",
        "Specialty": "Dermatology",
        "Summary": "Presence of comedones, papules, pustules, typically on the face, chest, and back.",
        "Keywords": ["acne", "vulgaris", "comedones", "pustules", "face", "back"],
        "Clue_1": "17 y/o presents with numerous inflamed lesions on his forehead and cheeks.",
        "Clue_2": "Lesions include open (blackheads) and closed (whiteheads) comedones, along with red papules.",
        "Clue_3": "Treated initially with topical retinoids and benzoyl peroxide.",
        "Clue_4": "Oral antibiotics or Isotretinoin may be necessary for severe cases.",
        "Clue_5": "Proper cleansing routines are essential for management.",
        "Max_Clues": 5
    },
    {
        "ID": "C035",
        "Correct Diagnosis": "Appendicitis",
        "Specialty": "Gastroenterology",
        "Summary": "Periumbilical pain migrating to the RLQ (McBurney's point), fever, and leukocytosis.",
        "Keywords": ["appendicitis", "rlq", "pain", "periumbilical", "mcburney"],
        "Clue_1": "20 y/o presents with vague periumbilical pain that migrated to the right lower quadrant (RLQ) over 12 hours.",
        "Clue_2": "Physical exam reveals guarding and rebound tenderness at McBurney's point.",
        "Clue_3": "Labs show elevated WBC count (Leukocytosis).",
        "Clue_4": "CT scan confirms an inflamed, non-compressible appendix.",
        "Clue_5": "Surgical appendectomy is the required treatment.",
        "Max_Clues": 5
    },
    {
        "ID": "C036",
        "Correct Diagnosis": "Carpal Tunnel Syndrome",
        "Specialty": "Orthopedics",
        "Summary": "Numbness and tingling in the thumb, index, and middle finger, often worse at night.",
        "Keywords": ["carpal", "tunnel", "median", "nerve", "paresthesia", "thumb"],
        "Clue_1": "50 y/o office worker complains of waking up at night with numbness and tingling in his hand.",
        "Clue_2": "Symptoms affect the thumb, index, and middle fingers.",
        "Clue_3": "Positive Tinel's sign and Phalen's maneuver elicited on exam.",
        "Clue_4": "Nerve conduction studies confirm delayed conduction across the wrist.",
        "Clue_5": "Initial treatment includes wrist splinting and corticosteroid injection.",
        "Max_Clues": 5
    },
    {
        "ID": "C037",
        "Correct Diagnosis": "Glomerulonephritis",
        "Specialty": "Nephrology",
        "Summary": "Hematuria, red cell casts, and mild proteinuria following a recent infection (strep throat).",
        "Keywords": ["glomerulonephritis", "hematuria", "casts", "strep", "post-infectious"],
        "Clue_1": "10 y/o presents with dark, cola-colored urine 10 days after recovering from 'strep throat'.",
        "Clue_2": "Urinalysis shows red blood cells and red blood cell casts.",
        "Clue_3": "Patient has periorbital edema and mild hypertension.",
        "Clue_4": "ASO titer is elevated, confirming recent Streptococcus infection.",
        "Clue_5": "Management is usually supportive, with diuretics for hypertension and edema.",
        "Max_Clues": 5
    },
    {
        "ID": "C038",
        "Correct Diagnosis": "Tuberculosis",
        "Specialty": "Pulmonology",
        "Summary": "Chronic cough, night sweats, weight loss, and characteristic apical cavitation on chest X-ray.",
        "Keywords": ["tuberculosis", "tb", "cough", "nights", "sweats", "weight"],
        "Clue_1": "40 y/o immigrant reports persistent cough, unexplained weight loss, and soaking night sweats for 3 months.",
        "Clue_2": "Physical exam is often nonspecific, but may show dullness to percussion.",
        "Clue_3": "Chest X-ray shows apical consolidation and cavitation.",
        "Clue_4": "PPD skin test is highly positive.",
        "Clue_5": "Confirmed by sputum acid-fast bacilli (AFB) smear and culture.",
        "Max_Clues": 5
    },
    {
        "ID": "C039",
        "Correct Diagnosis": "Meningioma",
        "Specialty": "Neurology",
        "Summary": "Slowly growing brain tumor, often asymptomatic, confirmed by MRI.",
        "Keywords": ["meningioma", "tumor", "slow", "growing", "mri", "brain"],
        "Clue_1": "60 y/o found to have an incidental brain lesion during imaging for headaches.",
        "Clue_2": "The tumor is located near the superior sagittal sinus and appears dural-based.",
        "Clue_3": "Lesion is confirmed as extra-axial and enhancing on MRI.",
        "Clue_4": "Patient remains neurologically intact due to slow growth.",
        "Clue_5": "Treatment ranges from observation to surgical resection or radiation.",
        "Max_Clues": 5
    },
    {
        "ID": "C040",
        "Correct Diagnosis": "Chronic Myeloid Leukemia",
        "Specialty": "Hematology",
        "Summary": "Extremely elevated WBC count (often >100,000) and presence of the Philadelphia chromosome (t(9;22)).",
        "Keywords": ["chronic", "myeloid", "leukemia", "cml", "wbc", "philadelphia"],
        "Clue_1": "50 y/o reports severe fatigue, left upper quadrant abdominal fullness, and weight loss.",
        "Clue_2": "Physical exam reveals massive splenomegaly.",
        "Clue_3": "CBC shows extremely high leukocytosis (>150,000) with a predominance of neutrophils.",
        "Clue_4": "Bone marrow analysis confirms the Philadelphia chromosome (BCR-ABL fusion gene).",
        "Clue_5": "Targeted therapy with Tyrosine Kinase Inhibitors (TKIs) is the standard treatment.",
        "Max_Clues": 5
    },
    {
        "ID": "C041",
        "Correct Diagnosis": "Angina Pectoris (Stable)",
        "Specialty": "Cardiology",
        "Summary": "Chest discomfort predictable with exertion and relieved promptly by rest or nitroglycerin.",
        "Keywords": ["angina", "stable", "chest", "discomfort", "exertion", "rest"],
        "Clue_1": "65 y/o reports chest tightness that occurs predictably when walking up a hill.",
        "Clue_2": "Discomfort lasts 5 minutes and is completely relieved by resting or taking sublingual nitroglycerin.",
        "Clue_3": "ECG during an episode shows transient ST depression.",
        "Clue_4": "Stress test results are positive for ischemia.",
        "Clue_5": "Managed primarily with Beta-blockers and statins.",
        "Max_Clues": 5
    },
    {
        "ID": "C042",
        "Correct Diagnosis": "Cluster Headache",
        "Specialty": "Neurology",
        "Summary": "Extremely severe, unilateral headache focused around the eye, accompanied by tearing and rhinorrhea.",
        "Keywords": ["cluster", "headache", "severe", "unilateral", "eye", "tear"],
        "Clue_1": "40 y/o male reports attacks of excruciating, sharp pain concentrated behind his left eye.",
        "Clue_2": "Attacks occur daily for several weeks, then vanish for months (clustering pattern).",
        "Clue_3": "Pain is accompanied by ipsilateral lacrimation (tearing) and nasal congestion (rhinorrhea).",
        "Clue_4": "Treated acutely with 100% oxygen inhalation or subcutaneous sumatriptan.",
        "Clue_5": "Alcohol consumption often triggers attacks.",
        "Max_Clues": 5
    },
    {
        "ID": "C043",
        "Correct Diagnosis": "Hypothyroidism (Hashimoto's)",
        "Specialty": "Endocrinology",
        "Summary": "Fatigue, weight gain, cold intolerance, and high TSH with low T4 suggests primary hypothyroidism.",
        "Keywords": ["hypothyroidism", "hashimotos", "fatigue", "cold", "tsh"],
        "Clue_1": "45 y/o female reports progressive fatigue, dry skin, and unintentional weight gain over the past year.",
        "Clue_2": "Physical exam reveals a slow heart rate (bradycardia) and puffiness around the eyes.",
        "Clue_3": "Labs show markedly elevated TSH and low free T4.",
        "Clue_4": "Serum antibodies against thyroid peroxidase (TPO) are positive.",
        "Clue_5": "Treated with synthetic thyroid hormone (Levothyroxine).",
        "Max_Clues": 5
    },
    {
        "ID": "C044",
        "Correct Diagnosis": "Contact Dermatitis",
        "Specialty": "Dermatology",
        "Summary": "Pruritic, erythematous rash at the site of contact with a known allergen (e.g., nickel, poison ivy).",
        "Keywords": ["contact", "dermatitis", "rash", "pruritic", "erythematous", "nickel"],
        "Clue_1": "25 y/o develops an intensely itchy, blistering rash localized exactly where his belt buckle contacts his skin.",
        "Clue_2": "The rash is red, vesicular, and linear in appearance.",
        "Clue_3": "Patient recalls recently switching to a belt with a cheap nickel buckle.",
        "Clue_4": "Patch testing confirms Type IV hypersensitivity reaction to nickel.",
        "Clue_5": "Treated with topical corticosteroids and avoidance of the allergen.",
        "Max_Clues": 5
    },
    {
        "ID": "C045",
        "Correct Diagnosis": "Celiac Disease",
        "Specialty": "Gastroenterology",
        "Summary": "Chronic diarrhea, malabsorption, iron deficiency, and positive tissue transglutaminase antibodies.",
        "Keywords": ["celiac", "malabsorption", "diarrhea", "ttg", "antibodies"],
        "Clue_1": "35 y/o reports chronic diarrhea, bloating, and foul-smelling stools; shows signs of iron deficiency.",
        "Clue_2": "Patient has persistent weight loss and fatigue.",
        "Clue_3": "Labs show positive Anti-Tissue Transglutaminase IgA (tTG-IgA) antibodies.",
        "Clue_4": "Endoscopic biopsy shows villous atrophy in the small intestine.",
        "Clue_5": "Strict gluten-free diet is the only effective treatment.",
        "Max_Clues": 5
    },
    {
        "ID": "C046",
        "Correct Diagnosis": "Osteoporosis",
        "Specialty": "Orthopedics",
        "Summary": "Decreased bone mineral density (BMD) leading to fragility fractures, confirmed by DEXA scan.",
        "Keywords": ["osteoporosis", "bmd", "fracture", "dexa", "fragile"],
        "Clue_1": "75 y/o postmenopausal female sustains a wrist fracture after a low-impact fall.",
        "Clue_2": "Patient reports significant loss of height over the last decade (vertebral compression).",
        "Clue_3": "DEXA scan shows T-score of -2.9 in the hip.",
        "Clue_4": "Labs rule out secondary causes of bone loss.",
        "Clue_5": "Treated with Calcium, Vitamin D, and Bisphosphonates.",
        "Max_Clues": 5
    },
    {
        "ID": "C047",
        "Correct Diagnosis": "Polycystic Kidney Disease",
        "Specialty": "Nephrology",
        "Summary": "Multiple renal cysts causing progressive renal failure, often with history of intracranial aneurysms.",
        "Keywords": ["polycystic", "kidney", "pckd", "cysts", "aneurysm", "flank", "pain"],
        "Clue_1": "40 y/o reports chronic, dull flank pain and history of multiple episodes of hematuria.",
        "Clue_2": "Physical exam reveals palpable, enlarged kidneys bilaterally.",
        "Clue_3": "Renal ultrasound confirms multiple large cysts replacing normal kidney parenchyma.",
        "Clue_4": "Patient has a positive family history of the disease.",
        "Clue_5": "Screening for intracranial 'berry' aneurysms is highly recommended.",
        "Max_Clues": 5
    },
    {
        "ID": "C048",
        "Correct Diagnosis": "Pneumothorax",
        "Specialty": "Pulmonology",
        "Summary": "Sudden onset sharp chest pain and dyspnea, accompanied by decreased breath sounds on one side.",
        "Keywords": ["pneumothorax", "chest", "pain", "dyspnea", "breath", "sounds"],
        "Clue_1": "30 y/o tall, thin male smoker reports sudden, sharp, unilateral chest pain and shortness of breath while sitting still.",
        "Clue_2": "Physical exam reveals reduced chest expansion and absent breath sounds on the affected side.",
        "Clue_3": "Chest X-ray confirms air accumulation in the pleural space, collapsing the lung.",
        "Clue_4": "Treated initially with chest tube insertion or needle decompression.",
        "Clue_5": "Smoking cessation is vital to prevent recurrence.",
        "Max_Clues": 5
    },
    {
        "ID": "C049",
        "Correct Diagnosis": "Varicella (Chickenpox)",
        "Specialty": "Infectious Disease",
        "Summary": "Generalized, vesicular rash in various stages of healing ('dewdrop on a rose petal'), highly contagious.",
        "Keywords": ["varicella", "chickenpox", "vesicular", "rash", "dewdrop"],
        "Clue_1": "5 y/o develops a generalized rash starting on the trunk and spreading outward.",
        "Clue_2": "The lesions are intensely itchy and described as clear vesicles on a red base.",
        "Clue_3": "Different stages of the rash (papules, vesicles, scabs) are present simultaneously.",
        "Clue_4": "Diagnosis is usually clinical, confirmed by Tzanck smear showing multinucleated giant cells.",
        "Clue_5": "Acyclovir may be used in immunocompromised patients.",
        "Max_Clues": 5
    },
    {
        "ID": "C050",
        "Correct Diagnosis": "Hemophilia A",
        "Specialty": "Hematology",
        "Summary": "Recurrent deep tissue and joint bleeding, confirmed by prolonged aPTT and factor VIII deficiency.",
        "Keywords": ["hemophilia", "a", "factor", "viii", "aptt", "deep", "joint", "bleed"],
        "Clue_1": "10 y/o male presents with persistent bleeding after a minor tooth extraction and recurrent swelling in his knees.",
        "Clue_2": "Labs show a prolonged aPTT (Activated Partial Thromboplastin Time) but normal PT.",
        "Clue_3": "Factor assay confirms severe deficiency of Factor VIII.",
        "Clue_4": "Joint damage is common due to repeated hemarthroses.",
        "Clue_5": "Treated with prophylactic or demand infusions of recombinant Factor VIII.",
        "Max_Clues": 5
    },
    {
        "ID": "C051",
        "Correct Diagnosis": "Coronary Artery Disease",
        "Specialty": "Cardiology",
        "Summary": "Diagnosis confirming chronic narrowing of the coronary arteries, often requiring angioplasty or bypass.",
        "Keywords": ["coronary", "artery", "disease", "cad", "narrowing", "angina"],
        "Clue_1": "65 y/o smoker reports chronic exertional chest pain managed with medication.",
        "Clue_2": "Cardiac catheterization confirms significant stenosis (>70%) in the left anterior descending artery.",
        "Clue_3": "ECG shows previous evidence of old infarcts.",
        "Clue_4": "Patient is managed with antiplatelet drugs (Aspirin) and aggressive statin therapy.",
        "Clue_5": "Smoking cessation is mandatory to slow disease progression.",
        "Max_Clues": 5
    },
    {
        "ID": "C052",
        "Correct Diagnosis": "Parkinson's Disease",
        "Specialty": "Neurology",
        "Summary": "Classic triad of resting tremor, rigidity, and bradykinesia (slow movement).",
        "Keywords": ["parkinsons", "tremor", "rigidity", "bradykinesia", "substantia"],
        "Clue_1": "68 y/o presents with a slow, shuffling gait and difficulty initiating movements.",
        "Clue_2": "Physical exam reveals a resting tremor that subsides with movement (pill-rolling).",
        "Clue_3": "Patient demonstrates 'cogwheel' rigidity upon passive movement of limbs.",
        "Clue_4": "Symptoms are caused by loss of dopaminergic neurons in the substantia nigra.",
        "Clue_5": "Managed with Levodopa/Carbidopa.",
        "Max_Clues": 5
    },
    {
        "ID": "C053",
        "Correct Diagnosis": "Cushing's Syndrome",
        "Specialty": "Endocrinology",
        "Summary": "Moon facies, central obesity, striae, and muscle wasting due to chronic cortisol excess.",
        "Keywords": ["cushings", "cortisol", "obesity", "striae", "moon", "facies"],
        "Clue_1": "45 y/o female reports rapid weight gain centered in her trunk, muscle weakness, and easy bruising.",
        "Clue_2": "Physical exam shows a 'buffalo hump', thin skin, and purple abdominal striae.",
        "Clue_3": "Diagnostic tests include 24-hour urinary free cortisol (UFC) and Dexamethasone suppression tests.",
        "Clue_4": "The underlying cause may be an adrenal tumor or ectopic ACTH production.",
        "Clue_5": "Treatment focuses on normalizing cortisol levels, often involving surgery.",
        "Max_Clues": 5
    },
    {
        "ID": "C054",
        "Correct Diagnosis": "Atopic Dermatitis (Eczema)",
        "Specialty": "Dermatology",
        "Summary": "Chronic, relapsing, pruritic inflammatory skin disease, often with history of asthma or rhinitis.",
        "Keywords": ["atopic", "dermatitis", "eczema", "chronic", "pruritus"],
        "Clue_1": "5 y/o presents with intensely itchy, dry, erythematous patches, mostly in the flexural folds (behind knees, inside elbows).",
        "Clue_2": "The skin is excoriated and lichenified due to chronic scratching.",
        "Clue_3": "Patient has a personal history of asthma and seasonal allergies (Atopic Triad).",
        "Clue_4": "Treated with emollients, hydration, and topical corticosteroids.",
        "Clue_5": "Triggers include dry air and harsh soaps.",
        "Max_Clues": 5
    },
    {
        "ID": "C055",
        "Correct Diagnosis": "Irritable Bowel Syndrome",
        "Specialty": "Gastroenterology",
        "Summary": "Recurrent abdominal pain associated with altered bowel habits (diarrhea, constipation) without structural abnormality.",
        "Keywords": ["irritable", "bowel", "syndrome", "ibs", "pain", "diarrhea", "constipation"],
        "Clue_1": "30 y/o reports recurrent abdominal pain relieved by defecation, associated with alternating diarrhea and constipation.",
        "Clue_2": "Symptoms have lasted for over a year and occur multiple times per month.",
        "Clue_3": "Diagnostic criteria (Rome IV) met based on symptom complex and absence of alarms.",
        "Clue_4": "Colonoscopy and labs are normal (ruling out structural disease).",
        "Clue_5": "Managed with dietary adjustments (FODMAPs) and symptom-specific medications.",
        "Max_Clues": 5
    },
    {
        "ID": "C056",
        "Correct Diagnosis": "Lateral Epicondylitis (Tennis Elbow)",
        "Specialty": "Orthopedics",
        "Summary": "Pain and tenderness over the lateral elbow, worsened by gripping or lifting objects.",
        "Keywords": ["lateral", "epicondylitis", "tennis", "elbow", "pain", "tendon"],
        "Clue_1": "40 y/o presents with chronic pain and tenderness on the outside of their dominant elbow.",
        "Clue_2": "Pain is exacerbated by gripping objects or extending the wrist against resistance.",
        "Clue_3": "Confirmed tenderness at the lateral epicondyle origin of the extensor tendons.",
        "Clue_4": "Repetitive strain from work tasks is the likely cause.",
        "Clue_5": "Treated with rest, anti-inflammatory drugs, and physical therapy focusing on eccentric exercises.",
        "Max_Clues": 5
    },
    {
        "ID": "C057",
        "Correct Diagnosis": "Nephrotic Syndrome",
        "Specialty": "Nephrology",
        "Summary": "Massive proteinuria, hypoalbuminemia, and severe edema.",
        "Keywords": ["nephrotic", "syndrome", "proteinuria", "hypoalbuminemia", "edema"],
        "Clue_1": "50 y/o develops severe, pitting edema starting in the feet and progressing to generalized anasarca.",
        "Clue_2": "Labs show serum albumin < 3.0 g/dL and total protein in urine exceeding 3.5 g/24h.",
        "Clue_3": "Hyperlipidemia is also present due to compensatory hepatic synthesis.",
        "Clue_4": "Renal biopsy needed to determine underlying cause (e.g., minimal change disease).",
        "Clue_5": "Treatment focuses on managing edema with diuretics and controlling proteinuria.",
        "Max_Clues": 5
    },
    {
        "ID": "C058",
        "Correct Diagnosis": "Pneumonia (Hospital-Acquired)",
        "Specialty": "Pulmonology",
        "Summary": "New-onset pneumonia symptoms appearing >48 hours after hospital admission.",
        "Keywords": ["pneumonia", "hospital", "acquired", "ventilator", "nosocomial"],
        "Clue_1": "65 y/o, admitted 4 days ago for heart failure, develops new fever, chills, and increased purulent sputum production.",
        "Clue_2": "Chest X-ray shows new infiltrate in the left lung base, absent on admission films.",
        "Clue_3": "Patient's respiratory status rapidly declines, requiring mechanical ventilation.",
        "Clue_4": "Cultures reveal multi-drug resistant Pseudomonas.",
        "Clue_5": "Treated aggressively with broad-spectrum IV antibiotics.",
        "Max_Clues": 5
    },
    {
        "ID": "C059",
        "Correct Diagnosis": "Herpes Zoster (Shingles)",
        "Specialty": "Infectious Disease",
        "Summary": "Painful vesicular rash confined to a single dermatome (unilateral, non-crossing midline).",
        "Keywords": ["herpes", "zoster", "shingles", "vesicular", "painful", "dermatome"],
        "Clue_1": "70 y/o reports severe burning pain, followed by a vesicular rash, confined to the right T4 region of the chest.",
        "Clue_2": "The rash is strictly unilateral and does not cross the midline of the back or chest.",
        "Clue_3": "Patient previously had chickenpox (Varicella Zoster Virus reactivation).",
        "Clue_4": "Treated with oral antiviral agents (Valacyclovir) to reduce pain duration.",
        "Clue_5": "Pain may persist long after the rash resolves (Postherpetic Neuralgia).",
        "Max_Clues": 5
    },
    {
        "ID": "C060",
        "Correct Diagnosis": "Thalassemia",
        "Specialty": "Hematology",
        "Summary": "Microcytic anemia that does not respond to iron, with elevated Hgb A2 confirmed by hemoglobin electrophoresis.",
        "Keywords": ["thalassemia", "microcytic", "hgb", "a2", "iron", "electrophoresis"],
        "Clue_1": "3 y/o child presents with mild pallor and persistent microcytic anemia (MCV 65) despite iron supplementation.",
        "Clue_2": "Peripheral smear shows target cells and basophilic stippling.",
        "Clue_3": "Serum ferritin levels are normal, ruling out iron deficiency.",
        "Clue_4": "Diagnosis confirmed by hemoglobin electrophoresis showing elevated HbA2.",
        "Clue_5": "Genetic counseling is provided to the family.",
        "Max_Clues": 5
    },
    {
        "ID": "C061",
        "Correct Diagnosis": "Viral Meningitis",
        "Specialty": "Neurology",
        "Summary": "Aseptic meningitis with fever and headache; CSF shows lymphocytosis and normal glucose.",
        "Keywords": ["viral", "meningitis", "aseptic", "csf", "lymphocyte"],
        "Clue_1": "20 y/o college student presents with headache and low-grade fever following a GI illness.",
        "Clue_2": "Physical exam shows mild nuchal rigidity but is otherwise unremarkable.",
        "Clue_3": "CSF analysis shows elevated lymphocytes, mildly elevated protein, and normal glucose.",
        "Clue_4": "Symptoms typically resolve spontaneously within 7-10 days.",
        "Clue_5": "Diagnosis is often presumptive after bacterial causes are ruled out.",
        "Max_Clues": 5
    },
    {
        "ID": "C062",
        "Correct Diagnosis": "Mitral Stenosis",
        "Specialty": "Cardiology",
        "Summary": "Diastolic murmur following an opening snap, usually caused by rheumatic fever.",
        "Keywords": ["mitral", "stenosis", "diastolic", "murmur", "opening", "snap"],
        "Clue_1": "45 y/o female from an endemic area presents with progressive dyspnea on exertion.",
        "Clue_2": "A distinct, low-pitched diastolic murmur is heard best at the apex.",
        "Clue_3": "Patient has a history of rheumatic fever as a child.",
        "Clue_4": "Echocardiogram confirms restricted opening of the mitral valve leaflets.",
        "Clue_5": "Anticoagulation is necessary if atrial fibrillation develops.",
        "Max_Clues": 5
    },
    {
        "ID": "C063",
        "Correct Diagnosis": "Hypoglycemia",
        "Specialty": "Endocrinology",
        "Summary": "Low blood sugar in a diabetic patient, causing tremor, confusion, and adrenergic symptoms.",
        "Keywords": ["hypoglycemia", "diabetic", "tremor", "confusion", "adrenergic"],
        "Clue_1": "60 y/o diabetic patient presents with sudden onset confusion, palpitations, and sweating.",
        "Clue_2": "Blood glucose reading is 45 mg/dL.",
        "Clue_3": "Patient is rapidly treated with oral glucose tablets or IV dextrose.",
        "Clue_4": "Symptoms immediately resolve following glucose administration.",
        "Clue_5": "Often caused by taking too much insulin or missing a meal.",
        "Max_Clues": 5
    },
    {
        "ID": "C064",
        "Correct Diagnosis": "Scabies",
        "Specialty": "Dermatology",
        "Summary": "Intensely pruritic rash with tiny burrows, typically found in webs of fingers or wrists.",
        "Keywords": ["scabies", "pruritic", "burrows", "fingers", "mites"],
        "Clue_1": "20 y/o military recruit reports severe, unrelenting itching, worse at night.",
        "Clue_2": "Rash consists of small vesicles and papules found primarily in the finger webs and wrist flexures.",
        "Clue_3": "Microscopic examination of skin scrapings reveals Sarcoptes scabiei mites.",
        "Clue_4": "Highly contagious, often requiring treatment of close contacts.",
        "Clue_5": "Treated with topical Permethrin or oral Ivermectin.",
        "Max_Clues": 5
    },
    {
        "ID": "C065",
        "Correct Diagnosis": "Crohn's Disease",
        "Specialty": "Gastroenterology",
        "Summary": "Transmural inflammation anywhere in the GI tract (skip lesions), often involving the terminal ileum.",
        "Keywords": ["crohns", "disease", "transmural", "skip", "terminal", "ileum"],
        "Clue_1": "25 y/o presents with chronic abdominal pain, bloody stools, and unintentional weight loss.",
        "Clue_2": "Colonoscopy shows segmental areas of inflammation separated by normal mucosa (skip lesions).",
        "Clue_3": "Biopsy shows non-caseating granulomas and deep fissuring ulcers (cobblestoning).",
        "Clue_4": "Inflammation is transmural, affecting all layers of the bowel wall.",
        "Clue_5": "Managed with immunosuppressants like Azathioprine or biologics.",
        "Max_Clues": 5
    },
    {
        "ID": "C066",
        "Correct Diagnosis": "Medial Tibial Stress Syndrome (Shin Splints)",
        "Specialty": "Orthopedics",
        "Summary": "Pain along the inner edge of the tibia, common in runners/military recruits.",
        "Keywords": ["medial", "tibial", "stress", "shin", "splints", "tibia", "runner"],
        "Clue_1": "20 y/o runner reports pain along the inner border of the lower leg, worsened by running.",
        "Clue_2": "Pain is diffuse along the tibia, unlike stress fracture pain which is pinpoint.",
        "Clue_3": "Commonly seen in athletes who rapidly increase their training intensity.",
        "Clue_4": "Physical therapy focuses on strengthening calf muscles and proper footwear.",
        "Clue_5": "Rest and ice are crucial for initial recovery.",
        "Max_Clues": 5
    },
    {
        "ID": "C067",
        "Correct Diagnosis": "Rhabdomyolysis",
        "Specialty": "Nephrology",
        "Summary": "Muscle breakdown releasing myoglobin, leading to AKI and dark urine.",
        "Keywords": ["rhabdomyolysis", "myoglobin", "creatinine", "kinase", "dark"],
        "Clue_1": "35 y/o presents with severe muscle pain (myalgia) and dark, tea-colored urine following intense exercise.",
        "Clue_2": "Labs show markedly elevated Creatinine Kinase (CK) levels (e.g., >20,000 U/L).",
        "Clue_3": "Urinalysis is positive for blood, but no red blood cells are seen microscopically.",
        "Clue_4": "Acute kidney injury results from myoglobin plugging the renal tubules.",
        "Clue_5": "Treatment requires aggressive IV fluid resuscitation (saline).",
        "Max_Clues": 5
    },
    {
        "ID": "C068",
        "Correct Diagnosis": "Sarcoidosis",
        "Specialty": "Pulmonology",
        "Summary": "Non-caseating granulomas, often affecting the lungs and skin, presenting with bilateral hilar adenopathy.",
        "Keywords": ["sarcoidosis", "granulomas", "hilar", "adenopathy", "lungs"],
        "Clue_1": "40 y/o reports persistent dry cough and fatigue; sometimes experiences painful red nodules on the shins (Erythema Nodosum).",
        "Clue_2": "Chest X-ray shows classic bilateral hilar lymphadenopathy.",
        "Clue_3": "Tissue biopsy (e.g., transbronchial) confirms non-caseating granulomas.",
        "Clue_4": "Serum ACE (Angiotensin-Converting Enzyme) levels are often elevated.",
        "Clue_5": "Managed with corticosteroids in symptomatic patients.",
        "Max_Clues": 5
    },
    {
        "ID": "C069",
        "Correct Diagnosis": "Syphilis (Primary)",
        "Specialty": "Infectious Disease",
        "Summary": "Painless chancre (ulcer) at the site of inoculation.",
        "Keywords": ["syphilis", "chancre", "ulcer", "painless", "treponema"],
        "Clue_1": "25 y/o presents with a single, firm, painless ulcer on the external genitalia.",
        "Clue_2": "The base of the ulcer is clean, and regional lymphadenopathy is present.",
        "Clue_3": "Rapid Plasma Reagin (RPR) screening test is positive.",
        "Clue_4": "Diagnosis confirmed by Dark-Field microscopy showing Treponema pallidum.",
        "Clue_5": "Treated with a single dose of intramuscular Penicillin G.",
        "Max_Clues": 5
    },
    {
        "ID": "C070",
        "Correct Diagnosis": "Myelodysplastic Syndrome",
        "Specialty": "Hematology",
        "Summary": "Cytopenias (anemia, neutropenia, thrombocytopenia) with hypercellular bone marrow and risk of transformation to AML.",
        "Keywords": ["myelodysplastic", "mds", "cytopenia", "hypercellular"],
        "Clue_1": "70 y/o reports increasing fatigue and frequent infections; found to have refractory anemia.",
        "Clue_2": "CBC shows macrocytic anemia, leukopenia, and thrombocytopenia (Pancytopenia).",
        "Clue_3": "Bone marrow biopsy is hypercellular with dysplastic changes.",
        "Clue_4": "Patient is at risk of transformation to Acute Myeloid Leukemia (AML).",
        "Clue_5": "Treatment often involves supportive care or chemotherapy/transfusion.",
        "Max_Clues": 5
    },
    {
        "ID": "C071",
        "Correct Diagnosis": "Diverticulitis",
        "Specialty": "Gastroenterology",
        "Summary": "LLQ abdominal pain, fever, and leukocytosis due to inflammation of colonic diverticula.",
        "Keywords": ["diverticulitis", "llq", "pain", "colon", "fever"],
        "Clue_1": "60 y/o reports acute onset left lower quadrant (LLQ) abdominal pain, fever, and nausea.",
        "Clue_2": "Physical exam reveals localized tenderness and guarding in the LLQ.",
        "Clue_3": "Labs show leukocytosis (elevated WBC count).",
        "Clue_4": "CT scan confirms inflammation and microperforation of a colonic diverticulum.",
        "Clue_5": "Managed initially with broad-spectrum antibiotics and bowel rest.",
        "Max_Clues": 5
    },
    {
        "ID": "C072",
        "Correct Diagnosis": "Systemic Lupus Erythematosus (SLE)",
        "Specialty": "Rheumatology",
        "Summary": "Multi-system autoimmune disorder characterized by a malar rash and positive ANA.",
        "Keywords": ["systemic", "lupus", "erythematosus", "sle", "malar", "rash", "butterfly"],
        "Clue_1": "30 y/o female reports joint pain, fatigue, and develops a red rash across her cheeks and nose after sun exposure.",
        "Clue_2": "Labs show positive Antinuclear Antibody (ANA) and anti-dsDNA antibodies.",
        "Clue_3": "Patient experiences intermittent fevers and pleuritic chest pain.",
        "Clue_4": "Diagnosis requires fulfillment of at least 4 out of 11 established criteria.",
        "Clue_5": "Treatment includes NSAIDs, antimalarials (Hydroxychloroquine), and corticosteroids.",
        "Max_Clues": 5
    },
    {
        "ID": "C073",
        "Correct Diagnosis": "Cholelithiasis",
        "Specialty": "Gastroenterology",
        "Summary": "Gallstones causing colicky RUQ pain following a fatty meal.",
        "Keywords": ["cholelithiasis", "gallstones", "ruq", "colicky", "fatty"],
        "Clue_1": "45 y/o female reports episodic, severe pain in the right upper quadrant (RUQ) that occurs shortly after eating a large, fatty meal.",
        "Clue_2": "Pain lasts for several hours and then subsides (biliary colic).",
        "Clue_3": "Abdominal ultrasound confirms the presence of mobile stones within the gallbladder lumen.",
        "Clue_4": "Labs are normal (no signs of inflammation or infection).",
        "Clue_5": "Managed by elective laparoscopic cholecystectomy.",
        "Max_Clues": 5
    },
    {
        "ID": "C074",
        "Correct Diagnosis": "Hypocalcemia",
        "Specialty": "Endocrinology",
        "Summary": "Low serum calcium leading to neuromuscular excitability (tetany, spasms).",
        "Keywords": ["hypocalcemia", "calcium", "tetany", "spasm"],
        "Clue_1": "40 y/o post-thyroidectomy patient reports tingling around the mouth and cramping in her hands and feet.",
        "Clue_2": "Physical exam is positive for Chvostek's sign and Trousseau's sign (latent tetany).",
        "Clue_3": "Labs confirm low serum Calcium and often elevated Phosphate.",
        "Clue_4": "Often caused by accidental removal of the parathyroid glands during neck surgery.",
        "Clue_5": "Treated with intravenous calcium gluconate.",
        "Max_Clues": 5
    },
    {
        "ID": "C075",
        "Correct Diagnosis": "Cellulitis",
        "Specialty": "Dermatology",
        "Summary": "Localized skin infection causing spreading erythema, warmth, and tenderness, often without clear margins.",
        "Keywords": ["cellulitis", "erythema", "warmth", "tenderness", "skin", "infection"],
        "Clue_1": "55 y/o presents with a rapidly spreading area of redness and swelling on their lower leg.",
        "Clue_2": "The area is warm to the touch and exquisitely tender; the margins are poorly demarcated.",
        "Clue_3": "Patient has a small abrasion or break in the skin as a likely entry point.",
        "Clue_4": "Labs show elevated CRP (C-Reactive Protein) and Leukocytosis.",
        "Clue_5": "Treated with empiric antibiotics targeting Streptococcus and Staphylococcus.",
        "Max_Clues": 5
    },
    {
        "ID": "C076",
        "Correct Diagnosis": "Subarachnoid Hemorrhage",
        "Specialty": "Neurology",
        "Summary": "'Worst headache of my life' (thunderclap), often due to rupture of a berry aneurysm.",
        "Keywords": ["subarachnoid", "hemorrhage", "sah", "thunderclap", "aneurysm"],
        "Clue_1": "50 y/o suddenly develops the 'worst headache of her life,' described as immediate and explosive.",
        "Clue_2": "Patient is nauseated, vomiting, and has mild nuchal rigidity.",
        "Clue_3": "Non-contrast head CT shows blood surrounding the basal cisterns (star sign).",
        "Clue_4": "Cerebral angiography confirms the presence of a ruptured berry aneurysm.",
        "Clue_5": "High risk of re-bleeding and vasospasm.",
        "Max_Clues": 5
    },
    {
        "ID": "C077",
        "Correct Diagnosis": "Systemic Sclerosis (Scleroderma)",
        "Specialty": "Rheumatology",
        "Summary": "Autoimmune disease causing skin thickening and organ fibrosis (CREST syndrome).",
        "Keywords": ["systemic", "sclerosis", "scleroderma", "crest", "fibrosis"],
        "Clue_1": "40 y/o female notes thickening and tightening of the skin on her fingers (sclerodactyly).",
        "Clue_2": "Patient reports Raynaud's phenomenon and difficulty swallowing (esophageal dysmotility).",
        "Clue_3": "Labs show positive Anti-Centromere or Anti-Scl-70 antibodies.",
        "Clue_4": "Pulmonary hypertension is a common complication.",
        "Clue_5": "Treatment focuses on managing organ-specific symptoms and immunosuppression.",
        "Max_Clues": 5
    },
    {
        "ID": "C078",
        "Correct Diagnosis": "Pyelonephritis",
        "Specialty": "Nephrology",
        "Summary": "Ascending UTI causing fever, flank pain, dysuria, and CVA tenderness.",
        "Keywords": ["pyelonephritis", "uti", "flank", "pain", "dysuria"],
        "Clue_1": "25 y/o female presents with high fever, nausea, vomiting, and severe pain in her right flank (costovertebral angle, CVA).",
        "Clue_2": "Physical exam is positive for CVA tenderness on the right side.",
        "Clue_3": "Urinalysis shows pyuria (WBCs), bacteriuria, and white blood cell casts.",
        "Clue_4": "Urine culture confirms significant growth of E. coli.",
        "Clue_5": "Treated with intravenous antibiotics (e.g., Ceftriaxone) initially.",
        "Max_Clues": 5
    },
    {
        "ID": "C079",
        "Correct Diagnosis": "Influenza",
        "Specialty": "Infectious Disease",
        "Summary": "Abrupt onset high fever, severe myalgia (muscle aches), and non-productive cough during winter months.",
        "Keywords": ["influenza", "flu", "fever", "myalgia", "cough", "winter"],
        "Clue_1": "30 y/o presents with abrupt onset of high fever (103°F), generalized body aches (myalgia), and headache.",
        "Clue_2": "Symptoms began suddenly 12 hours ago during peak flu season.",
        "Clue_3": "Rapid nasal swab test is positive for Influenza A.",
        "Clue_4": "Patient reports no productive cough or focal findings.",
        "Clue_5": "Treated with antiviral medication (Oseltamivir/Tamiflu) if started within 48 hours.",
        "Max_Clues": 5
    },
    {
        "ID": "C080",
        "Correct Diagnosis": "Aplastic Anemia",
        "Specialty": "Hematology",
        "Summary": "Pancytopenia (low RBCs, WBCs, Platelets) with a profoundly hypocellular bone marrow.",
        "Keywords": ["aplastic", "anemia", "pancytopenia", "hypocellular", "bone", "marrow"],
        "Clue_1": "25 y/o presents with fatigue, frequent infections, and easy bruising/bleeding.",
        "Clue_2": "CBC shows severe pancytopenia (low counts of all three cell lines).",
        "Clue_3": "Bone marrow biopsy is necessary and reveals a profoundly hypocellular marrow.",
        "Clue_4": "Often idiopathic, but can follow viral infection or drug exposure.",
        "Clue_5": "Treatment may involve immunosuppression or hematopoietic stem cell transplant.",
        "Max_Clues": 5
    },
    {
        "ID": "C081",
        "Correct Diagnosis": "Osteomyelitis",
        "Specialty": "Orthopedics",
        "Summary": "Infection of the bone, causing localized pain, fever, and elevated inflammatory markers.",
        "Keywords": ["osteomyelitis", "bone", "infection", "pain", "fever", "esr"],
        "Clue_1": "10 y/o child with a history of skin infection develops worsening localized pain and fever in the lower leg.",
        "Clue_2": "Physical exam shows exquisite point tenderness over the distal tibia and overlying erythema.",
        "Clue_3": "Labs show marked elevation in ESR and CRP.",
        "Clue_4": "X-ray is initially normal but MRI confirms bone edema and abscess.",
        "Clue_5": "Requires prolonged course of intravenous antibiotics.",
        "Max_Clues": 5
    },
    {
        "ID": "C082",
        "Correct Diagnosis": "Hyperosmolar Hyperglycemic State",
        "Specialty": "Endocrinology",
        "Summary": "Extreme hyperglycemia (>600 mg/dL), dehydration, and altered mental status without significant ketoacidosis.",
        "Keywords": ["hyperosmolar", "hyperglycemic", "state", "hhs", "dehydration", "glucose"],
        "Clue_1": "75 y/o Type 2 diabetic presents with several days of confusion, polyuria, and extreme lethargy.",
        "Clue_2": "Blood glucose level is critically high (780 mg/dL).",
        "Clue_3": "Labs show severe dehydration and high serum osmolality.",
        "Clue_4": "Unlike DKA, there are minimal ketones or anion gap acidosis.",
        "Clue_5": "Requires aggressive fluid resuscitation and insulin drip.",
        "Max_Clues": 5
    },
    {
        "ID": "C083",
        "Correct Diagnosis": "Peripheral Neuropathy",
        "Specialty": "Neurology",
        "Summary": "Distal, symmetric sensorimotor loss ('stocking-glove' pattern), often secondary to diabetes.",
        "Keywords": ["peripheral", "neuropathy", "distal", "symmetric", "stocking", "glove"],
        "Clue_1": "60 y/o diabetic reports chronic numbness, tingling, and sharp, burning pain starting in his feet.",
        "Clue_2": "Symptoms are bilaterally symmetric and progress up to the ankles (stocking pattern).",
        "Clue_3": "Physical exam shows decreased sensation to light touch and vibratory sense in the feet.",
        "Clue_4": "Nerve conduction studies show reduced conduction velocity.",
        "Clue_5": "Strict glucose control is the primary preventative measure.",
        "Max_Clues": 5
    },
    {
        "ID": "C084",
        "Correct Diagnosis": "Melanoma",
        "Specialty": "Dermatology",
        "Summary": "Malignant skin lesion diagnosed using the ABCDE criteria (Asymmetry, Border, Color, Diameter, Evolving).",
        "Keywords": ["melanoma", "malignant", "abcde", "evolving", "skin"],
        "Clue_1": "40 y/o presents with a mole on his back that has changed appearance over the last six months.",
        "Clue_2": "The lesion is asymmetric, has an irregular border, and contains multiple shades of brown/black (Color variation).",
        "Clue_3": "The diameter is >6 mm, and the patient reports it has been growing (Evolving).",
        "Clue_4": "Dermoscopy is used to evaluate the lesion structure.",
        "Clue_5": "Requires wide surgical excision with margin clearance.",
        "Max_Clues": 5
    },
    {
        "ID": "C085",
        "Correct Diagnosis": "Gastroenteritis (Viral)",
        "Specialty": "Gastroenterology",
        "Summary": "Self-limiting illness causing non-bloody vomiting and watery diarrhea, typically acquired from contaminated food/water.",
        "Keywords": ["gastroenteritis", "viral", "vomiting", "watery", "diarrhea"],
        "Clue_1": "25 y/o reports acute onset nausea, vomiting, and non-bloody, watery diarrhea starting 6 hours ago.",
        "Clue_2": "Patient reports several coworkers have similar symptoms (outbreak context).",
        "Clue_3": "Symptoms are typically self-limiting, peaking within 24 hours.",
        "Clue_4": "Stool culture is negative for bacterial pathogens.",
        "Clue_5": "Treatment is primarily supportive with oral rehydration solution (ORS).",
        "Max_Clues": 5
    },
    {
        "ID": "C086",
        "Correct Diagnosis": "Aortic Stenosis",
        "Specialty": "Cardiology",
        "Summary": "Ejection systolic murmur radiating to the neck (carotids), causing syncope and angina on exertion.",
        "Keywords": ["aortic", "stenosis", "systolic", "murmur", "syncope", "angina"],
        "Clue_1": "70 y/o reports episodes of dizziness (syncope) and exertional chest pain.",
        "Clue_2": "A loud, harsh systolic murmur is heard best at the right upper sternal border, radiating to the carotids.",
        "Clue_3": "Patient has a history of calcified aortic valve leaflets (calcification).",
        "Clue_4": "Echocardiogram shows reduced aortic valve area and high transvalvular gradient.",
        "Clue_5": "Definitive treatment is Aortic Valve Replacement (TAVR/SAVR).",
        "Max_Clues": 5
    },
    {
        "ID": "C087",
        "Correct Diagnosis": "Rheumatic Fever",
        "Specialty": "Infectious Disease",
        "Summary": "Autoimmune reaction post-strep infection causing migratory polyarthritis and carditis (JONES criteria).",
        "Keywords": ["rheumatic", "fever", "strep", "polyarthritis", "carditis"],
        "Clue_1": "10 y/o presents with migratory polyarthritis affecting the large joints and fever, 3 weeks after an untreated sore throat.",
        "Clue_2": "Labs show elevated ASO titers (anti-streptolysin O).",
        "Clue_3": "Patient develops a new, soft murmur (mitral regurgitation) indicative of carditis.",
        "Clue_4": "Diagnosis is based on Jones Criteria.",
        "Clue_5": "Requires long-term prophylactic penicillin to prevent recurrence.",
        "Max_Clues": 5
    },
    {
        "ID": "C088",
        "Correct Diagnosis": "Wegener's Granulomatosis (GPA)",
        "Specialty": "Nephrology",
        "Summary": "Vasculitis causing necrotizing granulomas in the upper/lower respiratory tract and rapidly progressive glomerulonephritis.",
        "Keywords": ["wegener's", "vasculitis", "anca", "kidney", "lung"],
        "Clue_1": "50 y/o reports chronic bloody nasal discharge, persistent cough, and rapid decline in kidney function.",
        "Clue_2": "Chest X-ray shows nodules and infiltrates (lung involvement).",
        "Clue_3": "Labs reveal positive c-ANCA (antineutrophil cytoplasmic antibodies).",
        "Clue_4": "Kidney biopsy shows necrotizing glomerulonephritis with crescent formation.",
        "Clue_5": "Treated with cyclophosphamide and high-dose corticosteroids.",
        "Max_Clues": 5
    },
    {
        "ID": "C089",
        "Correct Diagnosis": "Chronic Fatigue Syndrome",
        "Specialty": "Neurology",
        "Summary": "Severe, prolonged fatigue not relieved by rest and worsened by exertion, without an underlying medical cause.",
        "Keywords": ["chronic", "fatigue", "syndrome", "me/cfs", "prolonged", "post-exertional"],
        "Clue_1": "35 y/o reports debilitating fatigue lasting over 6 months, not relieved by rest.",
        "Clue_2": "Fatigue is severely worsened by physical or mental exertion (post-exertional malaise).",
        "Clue_3": "Extensive lab work and imaging ruled out all known infectious, endocrine, and rheumatologic causes.",
        "Clue_4": "Symptoms include cognitive dysfunction ('brain fog') and joint pain.",
        "Clue_5": "Management focuses on cognitive behavioral therapy and graded exercise protocols.",
        "Max_Clues": 5
    },
    {
        "ID": "C090",
        "Correct Diagnosis": "Pernicious Anemia",
        "Specialty": "Hematology",
        "Summary": "Macrocytic anemia with neurological symptoms (paresthesia), caused by intrinsic factor deficiency.",
        "Keywords": ["pernicious", "anemia", "macrocytic", "b12", "intrinsic", "factor"],
        "Clue_1": "65 y/o reports severe fatigue and developing numbness/tingling (paresthesias) in her hands and feet.",
        "Clue_2": "CBC shows macrocytic anemia (MCV 115 fL).",
        "Clue_3": "Serum Vitamin B12 levels are critically low.",
        "Clue_4": "Schilling test confirms malabsorption due to absence of intrinsic factor.",
        "Clue_5": "Treated with lifelong intramuscular injections of Vitamin B12.",
        "Max_Clues": 5
    },
    {
        "ID": "C091",
        "Correct Diagnosis": "Pneumothorax (Recurrent)",
        "Specialty": "Pulmonology",
        "Summary": "Recurrent episodes of spontaneous lung collapse requiring surgical intervention (pleurodesis).",
        "Keywords": ["pneumothorax", "recurrent", "spontaneous", "pleurodesis"],
        "Clue_1": "30 y/o male presents with his third episode of spontaneous pneumothorax in the last 18 months.",
        "Clue_2": "Chest X-ray shows apical blebs/bullae (emphysematous changes).",
        "Clue_3": "Surgical video-assisted thoracoscopic surgery (VATS) is planned.",
        "Clue_4": "The procedure will involve mechanical pleurodesis (talc or abrasion).",
        "Clue_5": "High risk of recurrence without definitive surgical management.",
        "Max_Clues": 5
    },
    {
        "ID": "C092",
        "Correct Diagnosis": "Multiple Myeloma",
        "Specialty": "Hematology",
        "Summary": "Plasma cell cancer presenting with 'CRAB' symptoms (HyperCalcemia, Renal failure, Anemia, Bone lesions).",
        "Keywords": ["multiple", "myeloma", "crab", "plasma", "bone"],
        "Clue_1": "70 y/o presents with unexplained back pain, fatigue, and recurrent infections.",
        "Clue_2": "Labs show high serum Calcium and high serum protein, often with renal insufficiency.",
        "Clue_3": "Skeletal survey shows multiple lytic, 'punched-out' lesions in the skull and spine.",
        "Clue_4": "Bone marrow biopsy shows >10% clonal plasma cells.",
        "Clue_5": "Serum protein electrophoresis (SPEP) shows a monoclonal spike (M-protein).",
        "Max_Clues": 5
    },
    {
        "ID": "C093",
        "Correct Diagnosis": "Atrial Flutter",
        "Specialty": "Cardiology",
        "Summary": "Rapid, regular atrial rhythm characterized by a 'sawtooth' pattern on ECG.",
        "Keywords": ["atrial", "flutter", "sawtooth", "atrial", "regular"],
        "Clue_1": "60 y/o reports palpitations and feeling lightheaded and short of breath.",
        "Clue_2": "ECG shows a rapid, regular atrial rate around 300 bpm.",
        "Clue_3": "The characteristic pattern on ECG is the 'sawtooth' baseline (F waves).",
        "Clue_4": "Patient has a history of chronic lung disease.",
        "Clue_5": "Managed with rate control medications or radiofrequency ablation.",
        "Max_Clues": 5
    },
    {
        "ID": "C094",
        "Correct Diagnosis": "Thyroid Storm",
        "Specialty": "Endocrinology",
        "Summary": "Life-threatening thyrotoxicosis with severe fever, delirium, and heart failure.",
        "Keywords": ["thyroid", "storm", "thyrotoxicosis", "fever", "delirium"],
        "Clue_1": "40 y/o presents with extreme agitation, high fever (105°F), vomiting, and severe tachycardia (HR 160).",
        "Clue_2": "Patient has a known history of Graves' disease but stopped taking medications recently.",
        "Clue_3": "Labs show extremely high free T4/T3 and suppressed TSH.",
        "Clue_4": "High suspicion of life-threatening thyrotoxicosis.",
        "Clue_5": "Treated aggressively with Beta-blockers, PTU (Propylthiouracil), and iodine solution.",
        "Max_Clues": 5
    },
    {
        "ID": "C095",
        "Correct Diagnosis": "Alopecia Areata",
        "Specialty": "Dermatology",
        "Summary": "Non-scarring, patchy hair loss, often abrupt onset, thought to be autoimmune.",
        "Keywords": ["alopecia", "areata", "patchy", "hair", "non-scarring"],
        "Clue_1": "25 y/o female notices small, coin-sized patches of hair loss on her scalp over the last few weeks.",
        "Clue_2": "Physical exam confirms smooth, non-scarred patches of baldness; 'exclamation point' hairs present at borders.",
        "Clue_3": "Patient has no other symptoms; underlying systemic disease is ruled out.",
        "Clue_4": "Treated with intralesional corticosteroids.",
        "Clue_5": "Treated with intralesional corticosteroids.",
        "Max_Clues": 5
    },
    {
        "ID": "C096",
        "Correct Diagnosis": "Neurofibromatosis Type 1 (NF1)",
        "Specialty": "Neurology",
        "Summary": "Genetic disorder causing neurofibromas, café-au-lait spots, and Lisch nodules.",
        "Keywords": ["neurofibromatosis", "nf1", "cafe", "au", "lait", "lisch"],
        "Clue_1": "10 y/o is noted to have multiple light brown, smooth skin lesions on the trunk and axillary freckling.",
        "Clue_2": "Physical exam reveals small, benign skin tumors (neurofibromas).",
        "Clue_3": "Slit lamp exam confirms pigmented hamartomas of the iris (Lisch nodules).",
        "Clue_4": "Diagnosis is clinical, based on established criteria (e.g., 6+ café-au-lait spots).",
        "Clue_5": "Managed with monitoring for potential tumor growth (optic pathway glioma).",
        "Max_Clues": 5
    },
    {
        "ID": "C097",
        "Correct Diagnosis": "Renal Cell Carcinoma",
        "Specialty": "Nephrology",
        "Summary": "Classic triad: hematuria, flank pain, and palpable abdominal mass (often late stage).",
        "Keywords": ["renal", "cell", "carcinoma", "rcc", "triad", "hematuria", "flank"],
        "Clue_1": "60 y/o smoker reports painless gross hematuria (blood in urine) that is intermittent.",
        "Clue_2": "Patient reports vague, persistent dull ache in the right flank.",
        "Clue_3": "CT scan of the abdomen reveals a large solid mass arising from the right kidney cortex.",
        "Clue_4": "Patient has significant history of tobacco use.",
        "Clue_5": "Treatment involves radical or partial nephrectomy.",
        "Max_Clues": 5
    },
    {
        "ID": "C098",
        "Correct Diagnosis": "Gastroenteritis (Bacterial)",
        "Specialty": "Gastroenterology",
        "Summary": "Diarrhea that is bloody or inflammatory, often accompanied by severe abdominal cramping and fever.",
        "Keywords": ["gastroenteritis", "bacterial", "bloody", "fever", "cramping"],
        "Clue_1": "45 y/o reports severe abdominal cramping and bloody diarrhea starting after eating chicken at a picnic.",
        "Clue_2": "Stool frequency is high, and fever is present.",
        "Clue_3": "Stool culture is sent to identify the causative organism (Salmonella, Campylobacter).",
        "Clue_4": "Treatment depends on the severity and specific pathogen.",
        "Clue_5": "Hydration is essential due to fluid loss.",
        "Max_Clues": 5
    },
    {
        "ID": "C099",
        "Correct Diagnosis": "Rheumatic Heart Disease",
        "Specialty": "Cardiology",
        "Summary": "Permanent cardiac valve damage (often mitral) resulting from untreated strep infection.",
        "Keywords": ["rheumatic", "fever", "strep", "polyarthritis", "carditis"],
        "Clue_1": "50 y/o presents with symptoms of heart failure and a history of recurrent fevers and joint pain in youth.",
        "Clue_2": "A new, soft murmur of Mitral Regurgitation or Stenosis is found.",
        "Clue_3": "Echocardiogram confirms structural damage and calcification of the mitral valve leaflets.",
        "Clue_4": "Prophylaxis with penicillin is recommended to prevent further valve damage.",
        "Clue_5": "Long-term risk includes atrial fibrillation and endocarditis.",
        "Max_Clues": 5
    },
    {
        "ID": "C100",
        "Correct Diagnosis": "Chronic Lymphocytic Leukemia",
        "Specialty": "Hematology",
        "Summary": "Smudge cells (fragile lymphocytes), generalized lymphadenopathy, and high absolute lymphocyte count in elderly patients.",
        "Keywords": ["chronic", "lymphocytic", "leukemia", "cll", "smudge", "lymphocyte"],
        "Clue_1": "70 y/o found to have persistently elevated absolute lymphocyte count (>20,000) during routine labs.",
        "Clue_2": "Patient reports generalized, painless swelling in the neck and armpits (lymphadenopathy).",
        "Clue_3": "Peripheral blood smear shows characteristic 'smudge cells'.",
        "Clue_4": "Flow cytometry confirms clonal B-lymphocytes (CD5, CD23 positive).",
        "Clue_5": "Treatment depends on patient symptoms and staging (watchful waiting is common).",
        "Max_Clues": 5
    }
];